/**
 * Keep the screenshot-style wall without CSS multicol fragmentation.
 * Reviews arrive in the HTML; this only groups the existing nodes into ordinary
 * vertical stacks. No scroll listeners, intersection observers, hiding, or clones.
 */
if (!customElements.get('review-wall')) {
  customElements.define('review-wall', class extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.review-shots__card'));
      this.mobile = window.matchMedia('(width < 750px)');
      this.tablet = window.matchMedia('(width < 1100px)');
      this.onBreakpoint = () => this.layout();
      this.mobile.addEventListener('change', this.onBreakpoint);
      this.tablet.addEventListener('change', this.onBreakpoint);
      this.layoutKey = '';
      this.layout();
    }

    disconnectedCallback() {
      this.mobile?.removeEventListener('change', this.onBreakpoint);
      this.tablet?.removeEventListener('change', this.onBreakpoint);
    }

    layout() {
      const requested = Math.max(1, Math.min(3, Number(this.dataset.columns) || 3));
      const columns = this.mobile.matches ? 1 : Math.min(requested, this.tablet.matches ? 2 : 3);
      const key = `${columns}:${this.mobile.matches}`;
      if (key === this.layoutKey || !this.cards.length) return;
      this.layoutKey = key;

      const isVisible = card => !card.classList.contains(
        this.mobile.matches ? 'review-shots__card--desktop-only' : 'review-shots__card--mobile-only'
      );
      const count = this.cards.filter(isVisible).length;
      const fragment = document.createDocumentFragment();
      const stacks = Array.from({ length: columns }, () => {
        const stack = document.createElement('div');
        stack.className = 'review-shots__column';
        fragment.append(stack);
        return stack;
      });
      const capacities = stacks.map((_, index) => Math.floor(count / columns) + (index < count % columns ? 1 : 0));
      let column = 0;
      let placed = 0;
      for (const card of this.cards) {
        if (placed >= capacities[column] && column < columns - 1) {
          column += 1;
          placed = 0;
        }
        stacks[column].append(card);
        if (isVisible(card)) placed += 1;
      }
      this.replaceChildren(fragment);
    }
  });
}
